import { getAuth, onAuthStateChanged, sendPasswordResetEmail, signInAnonymously, signInWithEmailAndPassword, signOut } from "firebase/auth";
//#region src/FirebaseAuthProvider.ts
/**
* Convert Firebase User to AuthUser interface
*/
function toAuthUser(user) {
	return {
		uid: user.uid,
		email: user.email,
		emailVerified: user.emailVerified,
		displayName: user.displayName,
		photoURL: user.photoURL,
		isAnonymous: user.isAnonymous
	};
}
/**
* Firebase implementation of IAuthProvider
*/
var FirebaseAuthProvider = class {
	constructor(app) {
		this.auth = getAuth(app);
	}
	async login(email, password) {
		return toAuthUser((await signInWithEmailAndPassword(this.auth, email, password)).user);
	}
	async loginAnonymously() {
		return toAuthUser((await signInAnonymously(this.auth)).user);
	}
	async logout() {
		await signOut(this.auth);
	}
	getCurrentUser() {
		const user = this.auth.currentUser;
		return user ? toAuthUser(user) : null;
	}
	isAuthenticated() {
		return this.auth.currentUser !== null;
	}
	async getIdToken(forceRefresh = false) {
		const user = this.auth.currentUser;
		if (!user) return null;
		return user.getIdToken(forceRefresh);
	}
	async getIdTokenResult(forceRefresh = false) {
		const user = this.auth.currentUser;
		if (!user) return null;
		const result = await user.getIdTokenResult(forceRefresh);
		return {
			token: result.token,
			claims: result.claims,
			expirationTime: result.expirationTime
		};
	}
	onAuthStateChanged(callback) {
		return onAuthStateChanged(this.auth, (user) => {
			callback(user ? toAuthUser(user) : null);
		});
	}
	async sendPasswordResetEmail(email) {
		await sendPasswordResetEmail(this.auth, email);
	}
	/**
	* Get the underlying Firebase Auth instance
	* (For Firebase-specific operations like getIdTokenResult with claims)
	*/
	getFirebaseAuth() {
		return this.auth;
	}
	/**
	* Get the underlying Firebase User
	* (For Firebase-specific operations)
	*/
	getFirebaseUser() {
		return this.auth.currentUser;
	}
};
//#endregion
export { FirebaseAuthProvider };
